
import Navbar from "../Navbar"
import ForgetOption from "./forgetOption"


export default function Forget(){
    return(<div className="loginContainer"  >
    <div className="tryi"><Navbar title="SignUp"/>
         <ForgetOption /></div>
         
        </div>
    
    
    )
}